import { render, staticRenderFns } from "./WabaSupsisMessageTemplateComponentsUpdate.vue?vue&type=template&id=f3154572&scoped=true"
import script from "./WabaSupsisMessageTemplateComponentsUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisMessageTemplateComponentsUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisMessageTemplateComponentsUpdate.vue?vue&type=style&index=0&id=f3154572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3154572",
  null
  
)

export default component.exports